import styled from "styled-components";

export const CourseContainer = styled.div.attrs({})`
  background: ${p => p.transparent ? 'transparent' : p.theme.palette.colors.white};
  height: 100%;
  width: 100%;
`;
